import { RadioCard, Title } from "@justhome/react-ui";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import useFormStep from "../../lib/useFormStep";
import ApartmentBuilding from "./images/apartment-building.svg";
import Apartment from "./images/apartment.svg";
import House from "./images/house.svg";
import Landplot from "./images/landplot.svg";

const TypeOfPropertyStep = ({
  skipPostalCode,
}: {
  skipPostalCode: boolean;
}) => {
  const { t } = useTranslation();
  const { form, handleSubmit, syntheticSubmit } = useFormStep({
    next: skipPostalCode ? "purchasePrice" : "postalCode",
  });
  const { watch, register } = form;

  const timeoutRef = useRef<number>(undefined);

  useEffect(() => {
    const subscription = watch((data, { name }) => {
      if (name === "propertyType" && data) {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(() => {
          syntheticSubmit();
        }, 200);
      }
    });

    return () => subscription.unsubscribe();
  }, [watch, syntheticSubmit]);

  return (
    <div className="grid grid-cols-12 gap-x-3s">
      <h2 className="col-span-12 m:col-span-5 m:col-start-2 text-h1 font-book text-balance">
        {t("typeOfProperty.title")}
        <br />
        {t("typeOfProperty.subtitle")}
      </h2>

      <div className="col-span-12 s:col-span-8 m:col-span-5 m:col-start-2 mt-m">
        <Title as="h3" className="text-h2 mb-m">
          {t("typeOfProperty.question")}
        </Title>
        <form onSubmit={handleSubmit}>
          <div className="space-y-3xs max-w-[380px]">
            <RadioCard
              {...register("propertyType")}
              type="radio"
              value="APARTMENT"
              icon={
                <Apartment
                  height="40"
                  width="40"
                  className="text-primary-800"
                />
              }
            >
              {t("typeOfProperty.apartment")}
            </RadioCard>
            <RadioCard
              {...register("propertyType")}
              type="radio"
              value="SINGLE_FAMILY_HOUSE"
              icon={
                <House height="40" width="40" className="text-primary-800" />
              }
            >
              {t("typeOfProperty.singleFamilyHouse")}
            </RadioCard>
            <RadioCard
              {...register("propertyType")}
              type="radio"
              value="APARTMENT_BUILDING"
              icon={
                <ApartmentBuilding
                  height="40"
                  width="40"
                  className="text-primary-800"
                />
              }
            >
              {t("typeOfProperty.apartmentBuilding")}
            </RadioCard>
            <RadioCard
              {...register("propertyType")}
              type="radio"
              value="LAND_PLOT"
              icon={
                <Landplot height="40" width="40" className="text-primary-800" />
              }
            >
              {t("typeOfProperty.landPlot")}
            </RadioCard>
          </div>
        </form>
      </div>
      <div className="hidden s:flex s:col-span-4 m:col-start-9 m:col-span-3 m:row-start-1 m:row-span-2 self-center justify-center">
        <div className="max-w-[220px] w-full">
          <img
            width="220"
            height="435"
            src="https://cdn.justhome.com/cdn/assets/application_phone_438b5cfa26.png"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default TypeOfPropertyStep;
